/**
 * BI event constants for the Unified Patients feature.
 * When changing dimensions or adding events, update ./BI-EVENTS.md accordingly.
 */
export const BI_FEATURE = 'unified-patients';

export const BI_CONTAINER = 'unified-patient-card';

export const BI_DIMENSIONS = {
	toggle: 'create-invisalign-patient-toggle',
	searchButton: 'patient-search-button',
	editButton: 'patient-edit-button',
	clearButton: 'patient-clear-button',
	reviewMatchesButton: 'patient-review-matches-button',
	matchBanner: 'match-exists-banner',
	duplicateBanner: 'duplicate-warning-banner',
	iteroPatientStatus: 'itero-patient-status',
	invisalignPatientStatus: 'invisalign-patient-status',
	linkageStatus: 'linkage-status'
} as const;

/** Possible values per dimension (for dimensions that carry state). */
export interface BiDimensionValues {
	[BI_DIMENSIONS.toggle]: 'on' | 'off' | 'hidden';
	[BI_DIMENSIONS.iteroPatientStatus]: 'new' | 'existing';
	[BI_DIMENSIONS.invisalignPatientStatus]: 'new' | 'existing' | 'not-relevant';
	[BI_DIMENSIONS.linkageStatus]: 'new' | 'existing' | 'none';
}
